<template>
    <div style="height:100%">
        <div id="csContainer">
             <div class="fogdiv">
             <el-checkbox class="shadow" size="small " v-model="checked" label="雨" border></el-checkbox>
          </div>
        </div>
    </div>
</template>

<script>
    import util from "../../components/util"

    export default {
        data() {
            return {
                checked:false,
                viewer: null
            }
        },
        watch:{
          checked(val){
             if(val){
               this.rain();
             }else{
               this.viewer.scene.postProcessStages.removeAll();
             }
          }
        },
        mounted() {
            this.init();
            // this.rain();
        },
        methods: {
            init() {
               this.viewer = util.getViewer("csContainer");
               util.setViewRegion( this.viewer);
            },
            //定义下雨场景 着色器
            FS_Rain() {
                let glsl = `
                uniform sampler2D colorTexture;
				varying vec2 v_textureCoordinates;

                float hash(float x){
                    return fract(sin(x*133.3)*13.13);
                }
                void main(void){
                    float time = czm_frameNumber / 60.0;
                    vec2 resolution = czm_viewport.zw;
                    vec2 uv=(gl_FragCoord.xy*2.-resolution.xy)/min(resolution.x,resolution.y);
                    vec3 c=vec3(.6,.7,.8);
                    float a=-.4;
                    float si=sin(a),co=cos(a);
                    uv*=mat2(co,-si,si,co);
                    uv*=length(uv+vec2(0,4.9))*.3+1.;
                    float v=1.-sin(hash(floor(uv.x*100.))*2.);
                    float b=clamp(abs(sin(20.*time*v+uv.y*(5./(2.+v))))-.95,0.,1.)*20.;
                    c*=v*b;
                    gl_FragColor = mix(texture2D(colorTexture, v_textureCoordinates), vec4(c,1), 0.5);
                }`;
                return glsl;
            },
            rain() {
                let collection = this.viewer.scene.postProcessStages;
                let fs_rain = this.FS_Rain();
                let snow = new Cesium.PostProcessStage({
                    name: 'czm_rain',
                    fragmentShader: fs_rain
                });
                collection.add(snow);

                // viewer.scene.skyAtmosphere.hueShift = -0.8;
                // viewer.scene.skyAtmosphere.saturationShift = -0.7;
                // viewer.scene.skyAtmosphere.brightnessShift = -0.33;
                // viewer.scene.fog.density = 0.001;
                // viewer.scene.fog.minimumBrightness = 0.8;
            }
        }
    }
</script>

<style scoped>
    #csContainer {
        height: 100%;
    }
    .fogdiv {
        position: absolute;
        margin-left: 25px;
        margin-top: 7px;
        z-index: 999;
        background-color: rgba(0, 0, 0, 0.5);
    }
    .shadow{
        color:white !important;
    }
</style>
